module.exports = __webpack_public_path__ + "5799d8d2ddd1b7c124f0872e0307d30e.svg";